import { DateRange } from "types/global";

export enum CYCLE_STATUS {
	UNKNOWN = 0,
	NEW = 1,
	PLANNED = 2,
	RUNNING = 3,
	HARVESTED = 4,
	REJECTED = 5,
}


export type FetchPayload = {
	/** id della farm da cui prelevare i dati */
	farmId?: number;
	/** non usato */
	growUnitId?: number;
	/** il range di date da caricare */
	dateRange?: DateRange;
	/** indica che se ne deve fregare che l'aveva gia' caricato e forzare il caricamento */
	force?: boolean;
	/** indica che i dati devono essere aggiunti a quelli gia' esistenti */
	add?: boolean;
};
